var map = {
	"./en/booking.json": 7310,
	"./en/common.json": 6951,
	"./en/dashboard.json": 1947,
	"./ja/booking.json": 9455,
	"./ja/common.json": 8519,
	"./ja/dashboard.json": 5032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 873;